import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBaseQuery } from "./customFetchBaseQuery";

export const apiProperty = createApi({
  reducerPath: "property",
  baseQuery: customFetchBaseQuery,
  keepUnusedDataFor: 0,
  refetchOnMountOrArgChange:0, 
  endpoints: (builder) => {
    return {
      getAutoCompleteResult: builder.query({
        query: (query) => `/api/property/${query}`,
      }),
      // getRecentlyAddedProperty: builder.query({
      //   query: () => `/api/property/recently-added`,
      // }),
      getAllStateList: builder.query({
        query: () => `/api/state/list`,
      }),
      getAllCityList: builder.query({
        query: () => `/api/city/list`,
      }),
      getAllLocalNewsList: builder.query({
        query: (query) => `/api/property/news/${query}`,
      }),
      getPropertyBasedOnLocation: builder.query({
        query: () => `/api/property/lat-long`,
      }),
      getWalkScore: builder.query({
        query: ({
          lat,
          lon,
          address,
        }: {
          lat: number;
          lon: number;
          address?: string;
        }) =>
          `/api/walk-score?lat=${lat}&lon=${lon}&address=${encodeURIComponent(
            address || ""
          )}`,
        // Unwrap the Response envelope so the component reads the payload
        // ({ available, scores, ... }) directly.
        transformResponse: (response: any) => response?.data,
        keepUnusedDataFor: 600, // scores are static; cache 10 min client-side
      }),
    };
  },
});

export const {
  useGetAutoCompleteResultQuery,
  useGetAllLocalNewsListQuery,
  useGetAllStateListQuery,
  useLazyGetPropertyBasedOnLocationQuery,
  useGetWalkScoreQuery,
} = apiProperty;
